export default "__VITE_ASSET__CmFnbhPm__"